import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import ModalNavigationButton from '../modal-navigation-button';

import LinkedElement from './linked-element';

import style from './linked-modal-navigation-button.module.less';

const LinkedModalNavigationButton = ({
  arrowDirection,
  className = null,
  disabled = false,
  hotkey: Hotkey,
  href = null,
  navigateTo,
  onBeforeNavigate = null,
}) => {
  const onNavigate = useCallback(() => {
    if (onBeforeNavigate) {
      onBeforeNavigate({ href });
      return;
    }

    navigateTo(href);
  }, [href, navigateTo, onBeforeNavigate]);

  // Using an onClick=onNavigate here to work around an issue currently in the Button component,
  // wherein all clicks get preventDefault'ed, which is also causing the anchor to not change the,
  // so for now, we'll change it with a push operation, the same as we would for a hotkey press.
  const linkedElement = (
    <LinkedElement className={style['linked-modal-navigation-button']} disabled={disabled} href={href}>
      <ModalNavigationButton arrowDirection={arrowDirection} className={className} disabled={disabled} onClick={onNavigate} />
    </LinkedElement>
  );

  if (disabled) {
    return linkedElement;
  }

  return <Hotkey onNavigate={onNavigate}>{linkedElement}</Hotkey>;
};

LinkedModalNavigationButton.propTypes = {
  arrowDirection: PropTypes.oneOf(['left', 'right']).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hotkey: PropTypes.func.isRequired,
  href: PropTypes.string,
  navigateTo: PropTypes.func.isRequired,
  onBeforeNavigate: PropTypes.func,
};

export default LinkedModalNavigationButton;
